import { _ } from "libs";

import React from "react";
import Avatar from "../../avatar";
import { Championship, ChampionshipLeague, OfficialRating } from "../../../types";
import { getLeagueInfo } from "./playerHelper";
import cx from "classnames";

const PlayerItemMedium = ({
	name,
	meta,
	photoUrl,
	isBuddy,
	coach,
	points,
	score,
	gender = "",
	className = "",
	officialRating = null,
	leagueId,
	isMember = null,
	disclosureButton = false,
	championship,
}: {
	name: string;
	meta: any; //string | Element;
	photoUrl: string;
	leagueId?: string;
	championship?: Championship;
	isBuddy?: boolean;
	coach?: string;
	points?: number;
	score?: number;
	gender?: string;
	className?: string;
	isMember?: boolean;
	officialRating?: OfficialRating;
	disclosureButton?: any;
}) => {
	const league: ChampionshipLeague | null = getLeagueInfo(championship, leagueId);
	const pointsLabel = <div className="points">{score >= 0 ? score : _("label.points", points, { points })}</div>;
	return (
		<div className={cx("item", "player", "medium", className)}>
			<div className={cx("itemImage", { itemImageWithRing: league })}>
				{isBuddy && <div className="buddy"></div>}
				{/* {officialRating?.code && <div className="verifiedRating"></div>} */}
				<Avatar
					photoUrl={photoUrl}
					size="thumb6"
					gender={gender}
					showLeagueRing={true}
					showLeagueBadge={false}
					league={league}
				/>
			</div>
			<div className="itemBody">
				<div className="title">{name}</div>
				<div className="meta">{meta}</div>
			</div>
			<div className="itemExtra">{points || score ? pointsLabel : ""}</div>
			<div className="itemBadge">
				{isMember === true && <div className="tag lightGreen">{_("player.member")}</div>}
				{isMember === false && <div className="tag grey">{_("player.guest")}</div>}
				{coach && coach === "pro" && <div className="badge coach pro">{_("coachType.pro")}</div>}
				{coach && coach === "sparring" && <div className="badge coach sparring">{_("coachType.sparring")}</div>}
			</div>
			{disclosureButton && (
				<div
					className="disclosureButton"
					onClick={(e) => {
						e.stopPropagation();
						disclosureButton();
					}}
				></div>
			)}
		</div>
	);
};

export default PlayerItemMedium;
